import transactionSession from '../instance';

const releaseTransactionSession = (contextType) => {
  const { context, isDedicated } = transactionSession.get();

  if (!isDedicated) {
    throw new Error('Only dedicated transaction session can be released');
  }

  if (contextType !== context) {
    throw new Error('Passed contextType does not match the context of the opened transaction');
  }

  transactionSession.reset();
};

export default releaseTransactionSession;
